import { JSX, PropsWithChildren } from 'react'
import { Box } from '@chakra-ui/react'

const LeftColumn = ({ children }: PropsWithChildren): JSX.Element => {
  return (
    <Box width="100%" maxWidth={{ base: '100%', lg: '40%' }}>
      {children}
    </Box>
  )
}

export default LeftColumn
